import { Injectable } from '@angular/core';
import { finalize, Observable, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ObservableCacheService {

constructor() { }


  private cache : {[ key: string] : Observable<any> | null} = {};


  /**
   * Cache an observable by key, and return the cached observable if it exists.
   * After the observable completes, the cache is cleared.
   * Use for observables, requests, etc. that should only be made once.   
   * i.e token requests, etc.
   * @param key 
   * @param observableFactory 
   * @returns 
   */
  public getCachedObservable<T>(key: string, observableFactory: () => Observable<T>) : Observable<T> {

    if(!this.cache[key]){
      this.cache[key] = observableFactory().pipe(
        // Keep only the latest value, and emit it immediately to new subscribers
        shareReplay(1),
        // Clear the cache when the observable completes
        // So the next time it's requested, it must be recreated
        finalize(() => {
          this.cache[key] = null;
        })
      );
    }
    return this.cache[key] as Observable<T>;

  }

}
